import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=12a7e7dc&scoped=true"
import script from "./Page.vue?vue&type=script&lang=ts"
export * from "./Page.vue?vue&type=script&lang=ts"
import style0 from "./Page.vue?vue&type=style&index=0&id=12a7e7dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a7e7dc",
  null
  
)

export default component.exports